import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Home.css";

function Home() {
  const { t } = useTranslation();

  const logoImage =
    "https://i.postimg.cc/cLRvTDG3/Whats-App-Image-2026-08-27-at-4-44-34-AM.jpg";

  const services = [
    {
      number: "01",
      title: t("home.service1Title"),
      text: t("home.service1Text"),
      className: "service-blue",
    },
    {
      number: "02",
      title: t("home.service2Title"),
      text: t("home.service2Text"),
      className: "service-yellow",
    },
    {
      number: "03",
      title: t("home.service3Title"),
      text: t("home.service3Text"),
      className: "service-red",
    },
    {
      number: "04",
      title: t("home.service4Title"),
      text: t("home.service4Text"),
      className: "service-blue",
    },
  ];

  return (
    <main className="home">

      {/* ================= HERO ================= */}
      <section className="hero">
        <div className="hero-background-shape"></div>

        <div className="hero-container">

          <div className="hero-text">

            <div className="hero-tag">
              <span></span>
              {t("home.heroTag")}
            </div>

            <h1>
              {t("home.heroTitle")}
              <br />
              <span>{t("home.heroTitle2")}</span>
            </h1>

            <p>{t("home.heroText")}</p>

            <div className="hero-actions">
              <Link to="/courses" className="main-button">
                {t("home.heroButton")}
                <span>←</span>
              </Link>

              <Link to="/about" className="outline-button">
                {t("home.heroButton2")}
              </Link>
            </div>

          </div>

          {/* HERO VISUAL */}
          <div className="hero-visual">

            <div className="hero-logo-wrapper">

              <div className="hero-logo-decoration decoration-one"></div>
              <div className="hero-logo-decoration decoration-two"></div>

              <div className="hero-logo-card">
                <div className="hero-logo-image-container">
                  <img
                    src={logoImage}
                    alt="مداد - MADAD"
                    className="hero-logo-image"
                  />
                </div>
              </div>

            </div>

            <div className="floating-card card-yellow">
              <b>✦</b>
              <span>{t("home.floating1")}</span>
            </div>

            <div className="floating-card card-red">
              <b>✦</b>
              <span>{t("home.floating2")}</span>
            </div>

            <div className="floating-card card-blue">
              <b>✓</b>
              <span>{t("home.floating3")}</span>
            </div>

          </div>

        </div>

        <div className="dot-pattern"></div>
        <div className="hero-red-circle"></div>
      </section>


      {/* ================= STATS ================= */}
      <section className="stats">

        <div className="stats-container">

          <div className="stats-title">
            <span>{t("home.statsTitle")}</span>
          </div>

          <div className="stat-item">
            <strong>500+</strong>
            <span>{t("home.students")}</span>
          </div>

          <div className="stat-item">
            <strong>20+</strong>
            <span>{t("home.programs")}</span>
          </div>

          <div className="stat-item">
            <strong>15+</strong>
            <span>{t("home.trainers")}</span>
          </div>

          <div className="stat-item">
            <strong>10+</strong>
            <span>{t("home.experience")}</span>
          </div>

        </div>

      </section>


      {/* ================= SERVICES ================= */}
      <section className="services">

        <div className="section-container">

          <div className="section-header">

            <span className="section-tag">
              {t("home.servicesTag")}
            </span>

            <h2>
              {t("home.servicesTitle")}
              <i>.</i>
            </h2>

          </div>


          <div className="services-grid">

            {services.map((service) => (

              <article
                key={service.number}
                className={`service-card ${service.className}`}
              >

                <div className="service-top">

                  <span className="service-number">
                    {service.number}
                  </span>

                  <div className="service-icon">
                    ✦
                  </div>

                </div>


                <div className="service-content">

                  <h3>
                    {service.title}
                  </h3>

                  <p>
                    {service.text}
                  </p>

                </div>


                <Link
                  to="/services"
                  className="service-link"
                >
                  {t("home.learnMore")}
                  <span>←</span>
                </Link>

              </article>

            ))}

          </div>

        </div>

      </section>


      {/* ================= WHY MADAD ================= */}
      <section className="why">

        <div className="why-container">

          <div className="why-visual">

            <div className="why-logo-circle">
              <img
                src={logoImage}
                alt="MADAD"
              />
            </div>

            <div className="why-label">
              MADAD
            </div>

            <div className="why-decoration"></div>

          </div>


          <div className="why-content">

            <span className="section-tag">
              {t("home.whyTag")}
            </span>

            <h2>
              {t("home.whyTitle")}
              <i>.</i>
            </h2>

            <p>
              {t("home.whyText")}
            </p>


            <div className="why-points">

              <div>
                <span>01</span>
                {t("home.point1")}
              </div>

              <div>
                <span>02</span>
                {t("home.point2")}
              </div>

              <div>
                <span>03</span>
                {t("home.point3")}
              </div>

              <div>
                <span>04</span>
                {t("home.point4")}
              </div>

            </div>


            <Link
              to="/about"
              className="main-button"
            >
              {t("home.whyButton")}
              <span>←</span>
            </Link>

          </div>

        </div>

      </section>


      {/* ================= CTA ================= */}
      <section className="cta">

        <div className="cta-shape"></div>

        <div className="cta-content">

          <span className="cta-star">
            ✦
          </span>

          <h2>
            {t("home.ctaTitle")}
          </h2>

          <p>
            {t("home.ctaText")}
          </p>

          <Link
            to="/registration"
            className="cta-button"
          >
            {t("home.ctaButton")}
            <span>←</span>
          </Link>

        </div>

      </section>

    </main>
  );
}

export default Home;